import axios from 'axios';
import authHeader from './auth-header';

//const API_URL = 'http://localhost:8080/matrix-mlm/api/mlm/netmem/';
const API_URL = 'https://www.edibleherbsstores.com/api/mlm/netmem/';

class MemberService {
  getAll() {
    return axios.get(API_URL + `member/all`, { headers: authHeader() });
  }

  getAllMembersPageable(surname, page, pageSize) {
    //return axios.get(API_URL + `member/${surname}/${page}/${pageSize}/all`, { headers: authHeader() } );
    return axios.get(API_URL + `member/allmeberspageable?surname=${surname}&page=${page}&size=${pageSize}`, { headers: authHeader() });
  }

  getAllMembersByMemId(memberId, page, pageSize) {
    return axios.get(API_URL + `member/allmeberspageablebymemid?memberId=${memberId}&page=${page}&size=${pageSize}`, { headers: authHeader() });
  }

  get(id) {
    return axios.get(API_URL + `member/${id}`, { headers: authHeader() });
  }
  
  getSponsorDownlinesNo(sponsor) {
    return axios.get(API_URL + `member/${sponsor}/sponsordownlinesno`, { headers: authHeader() });
  }
  
  getDescendants(id) {
    return axios.get(API_URL + `member/${id}/descendants`, { headers: authHeader() });
  }

  getDescendantsWithPageable(id, page, pageSize) {
    //return axios.get(API_URL + `member/${id}/${page}/${pageSize}/descendantspageable`, { headers: authHeader() });
    return axios.get(API_URL + `member/descendantswithpageable?id=${id}&page=${page}&size=${pageSize}`, { headers: authHeader() });
  }

  getDescendantsPageable(id, page, pageSize) {
    return axios.get(API_URL + `member/descendantspageable?id=${id}&page=${page}&size=${pageSize}`, { headers: authHeader() });
  }

  getDescendantsForNdcBySponsor(sponsor) {
    return axios.get(API_URL + `member/${sponsor}/descendantsforndcbysponsor`, { headers: authHeader() });
  }

  getDescendantsByUpline(upline) {
    return axios.get(API_URL + `member/${upline}/descendantsbyupline`, { headers: authHeader() });
  }

  create(member) {
    return axios.post(API_URL + `member/cre`, {
      id: member.id,
      networkMemberId: member.networkMemberId,
      surname: member.surname,
      firstName: member.firstName,
      middleName: member.middleName,
      gender: member.gender,
      address: member.address,
      country: member.country,
      state: member.state,
      dateOfBirth: member.dateOfBirth,
      phoneNumber: member.phoneNumber,
      email: member.email,
      sponsor: member.sponsor,
      level: member.level,
      upline: member.upline,
      joinedDate: member.joinedDate,
      idCardType: member.idCardType,
      idCardNumber: member.idCardNumber,
      photoUrl: member.photoUrl,
      bank: member.bank,
      accountNumber: member.accountNumber,
      accountName: member.accountName,
      rootId: member.rootId
    }, { headers: authHeader() });
  }

  update(id, member) {
    return axios.put(API_URL + `member/${id}/upd`, {
      id: member.id,
      networkMemberId: member.networkMemberId,
      surname: member.surname,
      firstName: member.firstName,
      middleName: member.middleName,
      gender: member.gender,
      address: member.address,
      country: member.country,
      state: member.state,
      dateOfBirth: member.dateOfBirth,
      phoneNumber: member.phoneNumber,
      email: member.email,
      sponsor: member.sponsor,
      level: member.level,
      upline: member.upline,
      joinedDate: member.joinedDate,
      idCardType: member.idCardType,
      idCardNumber: member.idCardNumber,
      photoUrl: member.photoUrl,
      bank: member.bank,
      accountNumber: member.accountNumber,
      accountName: member.accountName,
      rootId: member.rootId
    }, { headers: authHeader() });
  }

  updateMemberLevel(memberId, level) {
    return axios.put(API_URL + `member/${memberId}/${level}/updlevel`, {
      memberId: memberId,
      level: level
    }, { headers: authHeader() });
  }

  moveMember(memberId, sponsor) {
    return axios.get(API_URL + `movemember/${memberId}/${sponsor}`, { headers: authHeader() });
  }

  delete(id) {
    return axios.delete(API_URL + `del/${id}`, { headers: authHeader() });
  }

  deleteAll() {
    return axios.delete(API_URL + `delall`, { headers: authHeader() });
  }

  /*getBySurname(surname) {
    return axios.get(API_URL + `all?surname=${surname}`, { headers: authHeader() });
  }*/
  /*getBySurname(surname) {
    return axios.get(API_URL + `member/${surname}/bysurname`, { headers: authHeader() });
  }*/

  getMembersAllNdc() {
    return axios.get(API_URL + `member/allndc`, { headers: authHeader() });
  }

  getMemberFirstDownline(upline) {
    return axios.get(API_URL + `member/${upline}/memberfirstdownline`, { headers: authHeader() });
  }

  getDownlinesNo(id) {
    return axios.get(API_URL + `member/${id}/downlinesno`, { headers: authHeader() });
  }

  getLastRow() {
    return axios.get(API_URL + `member/lastrow`, { headers: authHeader() });
  }

  getFrontLinersCountBySponsor(sponsor) {
    return axios.get(API_URL + `member/${sponsor}/sponsor`, { headers: authHeader() });
  }

  memberExist(businessId) {
    return axios.get(API_URL + `member/${businessId}/memberexist`, { headers: authHeader() });
  }

  getUplineDownlineCount(memberId) {
    return axios.get(API_URL + `member/${memberId}/upline`, { headers: authHeader() });
  }

  getUplineAndValueDownlineCount(memberId, value) {
    return axios.get(API_URL + `member/${memberId}/${value}/uplineandvalue`, { headers: authHeader() });
  }

  getUplineAndAwardDownlineCount(memberId) {
    return axios.get(API_URL + `member/${memberId}/uplineandawarddownlinecount`, { headers: authHeader() });
  }

  getTotalMembers() {
    return axios.get(API_URL + `member/totalmembers`, { headers: authHeader() });
  }

  getTotalMembersBySurname(surname) {
    return axios.get(API_URL + `member/${surname}/totalmembersbysurname`, { headers: authHeader() });
  }

  getTotalMembersByMemberId(memberId) {
    return axios.get(API_URL + `member/${memberId}/totalmembersbymemberid`, { headers: authHeader() });
  }

  calculateFirstAward(memberId) {
    return axios.get(API_URL + `member/${memberId}/calculatefirstaward`, { headers: authHeader() });
  }

  calculateSecondAward(memberId) {
    return axios.get(API_URL + `member/${memberId}/calculatesecondaward`, { headers: authHeader() });
  }

  calculateThirdAward(memberId) {
    return axios.get(API_URL + `member/${memberId}/calculatethirdaward`, { headers: authHeader() });
  }

  calculateNewForthAward(memberId) {
    return axios.get(API_URL + `member/${memberId}/calculatenewforthaward`, { headers: authHeader() });
  }

  calculateNewFifthAward(memberId) {
    return axios.get(API_URL + `member/${memberId}/calculatenewfifthaward`, { headers: authHeader() });
  }

  calculateSixthAward(memberId) {
    return axios.get(API_URL + `member/${memberId}/calculatesixthaward`, { headers: authHeader() });
  }

  calculateAwardsData() {
    return axios.get(API_URL + `member/calculateawardsdata`, { headers: authHeader() });
  }

}

export default new MemberService();